import { Offer } from "../Model/Offer";
import { OffersPromoRepository } from "../Repository/OffersPromoRepository";

export interface CreateOfferUseCase {
  invoke: (data: Offer) => Promise<boolean>;
}

export class CreateOffer implements CreateOfferUseCase {

  private Repo: OffersPromoRepository;

  constructor(_Repo: OffersPromoRepository) {
    this.Repo = _Repo;
  }

  async invoke(data: Offer){

    if(!data){
        throw new Error(
            "Your todo should have at leat 2 characters."
          );
    }
     
    const created  = await this.Repo.createOffer(data);
    return created;
  }
}